import Raven from 'raven-js';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    const caughtError = new Error(`Error boundary hit by ${this.props.componentName}`, {
      cause: error
    });
    console.error(caughtError);
    // TO DO: set up graphana error logging
    Raven.captureException(caughtError);
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
export function withErrorBoundary(WrappedComponent, errorBoundaryProps) {
  return props => /*#__PURE__*/_jsx(ErrorBoundary, Object.assign({}, errorBoundaryProps, {
    children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
  }));
}